<template>
  <div class="modal-body modal-primary">
      <div class="row" style="margin:50px; margin-bottom: 20px;">
        <div class="col-sm-12 well center-block" style="position: relative; left: 0; top: 0;">
              <!-- <div id="Stage" class="EDGE-216448673"></div> -->
              <div>
                  <img src="static/images/nervous_remove/nervous-36.svg" :class="isNervous? 'nervous':''" style="position: relative;height:auto">
                  <img src="static/images/nervous_remove/nervous_eye1-37.svg" class="eye-move2" style="height:auto">
                  <img src="static/images/nervous_remove/nervous_eye2-39.svg" class="eye-move" style="height:auto">
                  <img src="static/images/nervous_remove/nervous_drop-38.svg" class="nervous-drop" style="height:auto">
                  <img src="static/images/nervous_remove/nervous_drop-382.svg" style="width: 308px; margin-left: 20px;height:auto" class="nervous-drop2">
              </div>
        </div>
      </div>
      <div class="center-block row" style="font-size:18px;">
        Unlinking will...
        <ul class="col-sm-9 col-sm-offset-2" style="text-align:left">
          <li>Remove the CLA assistant webhook in your repository</li>
          <li>Remove the link to your list of contributors</li>
        </ul>
      </div>

      <div slot="footer" class="dialog-footer" style="text-align:right">
        <button class="btn btn-cancel" @click="cancel()" style="width:80px; margin-top:5px">Keep it</button>
        <button class="btn btn-danger" :disabled="!selected.gist" @click="remove" @mouseenter="isNervous=true" @mouseleave="isNervous=false" style="width:120px">Unlink anyway</button>
      </div>
  </div> 
</template>

<script>
import {RemoveRepoOrOrg} from '@/api/home'

export default {
  props:{
    selected:{}
  },
  data() {
    return {
      isNervous:false
    };
  },

  methods: {
    cancel() {
      this.$emit('close')
    },
    remove() {
        let type = 'repo'
        var data = {
            repoId: this.selected.repoId
        };
        RemoveRepoOrOrg(type, data).then(() =>{
          this.$emit('refresh', type)
          
        }).catch((err) =>{
          this.$message.error(err);
        })
    }
  }
}

</script>
<style>
</style>


// WEBPACK FOOTER //
// src/javascript/home/components/modal/confirmRemove.vue